/**
 * @fileoverview Recoveries overview — redirect stub
 *
 * The Recoveries phase is hidden in the sidebar for now; Proof of Debt
 * is a top-level job-nav item. `/recoveries` stays a valid URL so existing
 * links (creditor POD deep-links, bookmarks) still resolve, and sends
 * everyone to the Proof of Debt workspace.
 *
 * URL: /dashboard/jobs/:jobId/recoveries → /recoveries/proof-of-debt
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_app/_auth/dashboard/_layout/jobs/$jobId/recoveries/",
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/dashboard/jobs/$jobId/recoveries/$section",
      params: { jobId: params.jobId, section: "proof-of-debt" },
    });
  },
});
